/* Holy Skin, cadeaux par palier (13/10/2026). Remplace l'app EG Auto Add to Cart.
   - 60 EUR : cadeau ajouté automatiquement.
   - 100 EUR et 150 EUR : fenêtre de choix ; si la cliente ferme, un rappel reste dans le panier.
   - Le seuil est calculé sans les cadeaux (lignes portant la propriété cachée _hs_cadeau).
   - Sous le seuil, le cadeau est retiré. Un cadeau supprimé à la main n'est pas remis pendant la session.
   La gratuité vient des réductions automatiques Shopify, pas de ce script. */
(function () {
  'use strict';
  var cfgEl = document.getElementById('hs-cadeaux-config');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var KEY = '_hs_cadeau';
  var origFetch = window.fetch.bind(window);
  var lastCart = null;
  var busy = false;
  var again = false;
  var timer = null;
  var modal = null;
  var EN = /^en/i.test(document.documentElement.lang || ''); /* 17/10/2026 : libelles anglais sur /en */

  var store = {
    get: function (k) { try { return sessionStorage.getItem('hs_cadeau_' + k); } catch (e) { return null; } },
    set: function (k, v) { try { sessionStorage.setItem('hs_cadeau_' + k, v); } catch (e) { /* stockage indisponible */ } },
    del: function (k) { try { sessionStorage.removeItem('hs_cadeau_' + k); } catch (e) { /* stockage indisponible */ } }
  };

  function isCartMutation(url) { return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url); }
  function giftTier(item) { return item && item.properties && item.properties[KEY] ? String(item.properties[KEY]) : null; }

  /* Repère une suppression manuelle de cadeau (quantité 0 sur une ligne cadeau) pour ne pas le remettre. */
  function noteRefusal(url, init) {
    if (!lastCart || !init || !init.body || !/\/cart\/change/.test(url)) return;
    var body = null;
    try {
      if (typeof init.body === 'string') body = JSON.parse(init.body);
      else if (init.body instanceof FormData) { body = {}; init.body.forEach(function (v, k) { body[k] = v; }); }
    } catch (e) { return; }
    if (!body || Number(body.quantity) !== 0) return;
    var item = null;
    if (body.line) item = lastCart.items[Number(body.line) - 1];
    else if (body.id) item = lastCart.items.filter(function (i) { return i.key === body.id || String(i.variant_id) === String(body.id); })[0];
    var t = giftTier(item);
    if (t) store.set('refus_' + t, '1');
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (isCartMutation(url)) noteRefusal(url, init);
    var p = origFetch(input, init);
    if (isCartMutation(url)) p.then(function () { schedule(); }, function () {});
    return p;
  };

  function schedule() { clearTimeout(timer); timer = setTimeout(check, 250); }

  function getCart() { return origFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

  function drawer() { return document.querySelector('cart-drawer'); }

  /* Rafraîchit le tiroir panier (et l'icône) avec le rendu de section du thème, sinon recharge la page panier. */
  function refreshUI() {
    if (/^\/cart\/?$/.test(location.pathname)) { location.reload(); return Promise.resolve(); }
    /* Le tiroir du theme est defini par un script externe : on attend qu'il soit pret (sinon le panier affiche resterait ancien). */
    var ready = window.customElements && customElements.whenDefined ? Promise.race([customElements.whenDefined('cart-drawer'), new Promise(function (r) { setTimeout(r, 4000); })]) : Promise.resolve();
    return ready.then(function () {
    var cd = drawer();
    if (!cd || typeof cd.getSectionsToRender !== 'function' || typeof cd.renderContents !== 'function') return null;
    var ids = cd.getSectionsToRender().map(function (s) { return s.section || s.id; }).filter(Boolean);
    return origFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: {}, sections: ids, sections_url: location.pathname })
    }).then(function (r) { return r.json(); }).then(function (state) {
      try {
        if (cd.classList.contains('active')) { cd.renderContents(state); return; }
        /* Tiroir ferme : on met a jour son contenu et la pastille sans l'ouvrir. */
        var secs = state.sections || {};
        var parse = function (h) { return new DOMParser().parseFromString(h || '', 'text/html'); };
        if (secs['cart-drawer']) { var nd = parse(secs['cart-drawer']).querySelector('#CartDrawer'); var od = document.querySelector('#CartDrawer'); if (nd && od) od.replaceWith(nd); }
        if (secs['cart-icon-bubble']) { var nb = parse(secs['cart-icon-bubble']).querySelector('.shopify-section'); var ob = document.getElementById('cart-icon-bubble'); if (nb && ob) ob.innerHTML = nb.innerHTML; }
      } catch (e) { /* rendu du thème indisponible */ }
    });
    });
  }

  function post(url, payload) {
    return origFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); });
  }

  function check() {
    if (busy) { again = true; return; }
    busy = true;
    getCart().then(function (cart) {
      lastCart = cart;
      /* 15/10/2026 : palier sur le montant paye, codes de reduction deduits (total du panier moins les lignes cadeaux). */
      var base = cart.total_price - cart.items.reduce(function (s, it) { return giftTier(it) ? s + it.final_line_price : s; }, 0);
      var updates = {};
      var adds = [];
      var toChoose = [];
      /* 15/10/2026 : cadeaux a 0 EUR. Retire (1) un produit cadeau ajoute hors module, (2) un ancien cadeau = vrai produit marque _hs_cadeau (paniers d'avant le 14/10), que le module remplace ensuite par le cadeau a 0 EUR. */
      cart.items.forEach(function (it) { var g = it.product_type === 'Cadeau offert'; if ((g && !giftTier(it)) || (!g && giftTier(it))) updates[it.key] = 0; });
      CFG.paliers.forEach(function (t) {
        var tier = String(t.seuil);
        var lines = cart.items.filter(function (it) { return giftTier(it) === tier && it.product_type === 'Cadeau offert'; });
        if (base < t.seuil * 100) {
          lines.forEach(function (it) { updates[it.key] = 0; });
          store.del('refus_' + tier);
          store.del('ferme_' + tier);
          return;
        }
        lines.forEach(function (it, i) { if (i > 0) updates[it.key] = 0; else if (it.quantity > 1) updates[it.key] = 1; });
        if (lines.length || store.get('refus_' + tier) || !t.produits.length) return;
        if (t.mode === 'auto') adds.push({ id: t.produits[0].variante, quantity: 1, properties: { _hs_cadeau: tier } });
        else toChoose.push(t);
      });
      var steps = Promise.resolve();
      var changed = false;
      if (Object.keys(updates).length) { changed = true; steps = steps.then(function () { return post('/cart/update.js', { updates: updates }); }); }
      if (adds.length) { changed = true; steps = steps.then(function () { return post('/cart/add.js', { items: adds }); }); }
      /* 15/10/2026 : relire le panier apres nos propres ajouts, pour reconnaitre ensuite un cadeau supprime a la main. */
      return steps.then(function () { return changed ? getCart().then(function (c2) { lastCart = c2; return refreshUI(); }) : null; }).then(function () {
        var next = toChoose.filter(function (t) { return !store.get('ferme_' + t.seuil); })[0];
        if (next) openModal(next);
      });
    }).catch(function () { /* réseau : on réessaiera au prochain changement */ }).then(function () {
      busy = false;
      if (again) { again = false; schedule(); }
    });
  }

  function findTier(seuil) { return CFG.paliers.filter(function (t) { return String(t.seuil) === String(seuil); })[0]; }

  function closeModal(remember) {
    if (!modal) return;
    if (remember && modal.dataset.seuil) store.set('ferme_' + modal.dataset.seuil, '1');
    modal.hidden = true;
    modal.dataset.seuil = '';
    /* 15/10/2026 : proposer tout de suite le palier suivant (ex. masque refuse, tote a 150 EUR). */
    if (remember) schedule();
  }

  function openModal(t) {
    if (!modal) {
      modal = document.createElement('div');
      modal.className = 'hs-cadeau-modal';
      modal.hidden = true;
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-labelledby', 'hs-cadeau-titre');
      modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(true); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal && !modal.hidden) closeModal(true); });
      document.body.appendChild(modal);
    }
    var esc = function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; };
    var items = t.produits.map(function (p) {
      p = Object.assign({}, p, { titre: String(p.titre || '').replace(/^Cadeau\s*[–-]\s*/, '') });
      return '<li><button type="button" class="hs-cadeau-carte" data-hs-variante="' + esc(p.variante) + '">' +
        '<span class="hs-cadeau-carte__media">' +
        (p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.titre) + '" width="400" height="400">' : '') +
        (p.image2 ? '<img class="is-second" src="' + esc(p.image2) + '" alt="" width="400" height="400">' : '') +
        '</span><span class="hs-cadeau-carte__nom">' + esc(p.titre) + '</span>' +
        '<span class="hs-cadeau-carte__btn">' + (EN ? 'Choose' : 'Choisir') + '</span></button></li>';
    }).join('');
    modal.innerHTML = '<div class="hs-cadeau-modal__box">' +
      '<button type="button" class="hs-cadeau-modal__fermer" aria-label="' + (EN ? 'Close' : 'Fermer') + '"><svg aria-hidden=\"true\" focusable=\"false\" class=\"icon icon-close\" fill=\"none\" viewBox=\"0 0 18 17\"><path d=\"M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z\" fill=\"currentColor\"></path></svg></button>' +
      '<p class="hs-cadeau-modal__titre" id="hs-cadeau-titre">' + esc(t.titre) + '</p>' +
      '<p class="hs-cadeau-modal__sous">' + esc(t.sous_titre) + '</p>' +
      '<ul class="hs-cadeau-modal__liste">' + items + '</ul>' +
      '<button type="button" class="hs-cadeau-modal__plus-tard">' + (EN ? 'Maybe later' : 'Plus tard') + '</button></div>';
    modal.dataset.seuil = String(t.seuil);
    modal.querySelector('.hs-cadeau-modal__plus-tard').addEventListener('click', function () { closeModal(true); });
    modal.querySelector('.hs-cadeau-modal__fermer').addEventListener('click', function () { closeModal(true); });
    Array.prototype.forEach.call(modal.querySelectorAll('[data-hs-variante]'), function (btn) {
      btn.addEventListener('click', function () { choose(t, btn); });
    });
    modal.hidden = false;
    var boite = modal.querySelector('.hs-cadeau-modal__box');
    if (boite) { boite.setAttribute('tabindex', '-1'); boite.style.outline = 'none'; boite.focus(); }
  }

  function choose(t, btn) {
    Array.prototype.forEach.call(modal.querySelectorAll('button'), function (b) { b.disabled = true; });
    var tier = String(t.seuil);
    store.del('refus_' + tier);
    getCart().then(function (cart) {
      var updates = {};
      cart.items.forEach(function (it) { if (giftTier(it) === tier) updates[it.key] = 0; });
      return Object.keys(updates).length ? post('/cart/update.js', { updates: updates }) : null;
    }).then(function () {
      return post('/cart/add.js', { items: [{ id: Number(btn.dataset.hsVariante), quantity: 1, properties: { _hs_cadeau: tier } }] });
    }).then(function () {
      modal.hidden = true;
      return refreshUI();
    }).then(function () {
      var cd = drawer();
      if (cd && typeof cd.open === 'function' && !cd.classList.contains('active')) { try { cd.open(); } catch (e) { /* tiroir indisponible */ } }
      schedule();
    }).catch(function () {
      Array.prototype.forEach.call(modal.querySelectorAll('button'), function (b) { b.disabled = false; });
    });
  }

  /* Rappel dans le panier : bouton « Choisir » rendu par le bloc Liquid du tiroir. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-hs-cadeau-ouvrir]') : null;
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    var t = findTier(b.getAttribute('data-hs-cadeau-ouvrir'));
    if (!t) return;
    store.del('ferme_' + t.seuil);
    store.del('refus_' + t.seuil);
    openModal(t);
  }, true);

  /* Premier passage au chargement (panier déjà rempli, retour sur le site). */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
})();
